// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import setHeaderHeight from "@store/Framework/Store/Bunzl/Components/Header/Handlers/SetHeaderHeight";
import { HeaderHeightParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";

export default () => {
    const dispatch = useAppDispatch();

    return (parameter: HeaderHeightParameter) => {
        dispatch(setHeaderHeight(parameter));
    };
};
